import { Ref } from 'vue'

type RefreshableGridRef = Ref<{ instance?: { refresh: () => void } } | null>

// Debounces a search input's grid refresh -- each call resets the timer so only the last
// keystroke within delayMs actually triggers a reload.
export function useDebouncedGridRefresh(gridRef: RefreshableGridRef, delayMs = 300) {
  let timer: ReturnType<typeof setTimeout> | null = null
  return () => {
    if (timer) clearTimeout(timer)
    timer = setTimeout(() => gridRef.value?.instance?.refresh(), delayMs)
  }
}
